<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  multiTemplateDataRows
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="select">
    <mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="masterToggle()"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
      >
      </mat-checkbox>
    </mat-header-cell>
    <mat-cell *matCellDef="let item">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (dblclick)="$event.stopPropagation()"
        (change)="selection.toggle(item)"
        [checked]="selection.isSelected(item)"
      >
      </mat-checkbox>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="record">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'cameras.table.columns.record' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-camera-record-status
        [record]="item.record || item.playbackUrls"
      ></sn-camera-record-status>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.name' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      {{ item.name }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="make">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'cameras.table.columns.make' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">{{ item.make }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="cameraMakeIcon">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'cameras.table.columns.make' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span *ngIf="!getCameraIcon(item.make).hasIcon" class="fs-text-truncate">{{ item.make }}</span>
      <sn-icon
        [matTooltip]="item.make"
        *ngIf="getCameraIcon(item.make).hasIcon"
        fontSet="fs"
        [fontIcon]="getCameraIcon(item.make).makeIcon"
      ></sn-icon>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="model">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.model' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">{{ item.model }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="control">
    <mat-header-cell *matHeaderCellDef mat-sort-header="type">{{ 'common.control' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">{{ item.type }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="isStarred">
    <mat-header-cell *matHeaderCellDef>{{ 'cameras.table.columns.favorite' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container *ngIf="item.starred">
        <button
          mat-icon-button
          [matTooltip]="'cameras.table.tooltips.unfavoriteCamera' | t"
          (click)="$event.stopPropagation(); toggleNotStarred(item)"
        >
          <sn-icon class="starred" fontSet="fas" fontIcon="fa-star"></sn-icon>
        </button>
      </ng-container>
      <ng-container *ngIf="!item.starred">
        <button
          mat-icon-button
          [matTooltip]="'cameras.table.tooltips.favoriteCamera' | t"
          (click)="$event.stopPropagation(); toggleStarred(item)"
        >
          <sn-icon fontSet="fal" fontIcon="fa-star"></sn-icon>
        </button>
      </ng-container>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="disposition">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.disposition' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">{{ item.disposition }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="owner">
    <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-owner [object]="item"></sn-object-owner>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="sharing">
    <mat-header-cell *matHeaderCellDef>{{ 'common.sharing' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-share-status [object]="item"></sn-object-share-status>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef mat-sort-header="status_repr_db">{{ 'common.status' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-camera-status *ngIf="item.status" [status]="item.status"></sn-camera-status>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="floor">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.floor' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">{{ item.floor?.name }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="tags">
    <mat-header-cell *matHeaderCellDef>{{ 'common.tags' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-tag-view-list
        [tags]="item.tags"
        (tagSelected)="onTagSelected($event)"
        (click)="$event.stopPropagation()"
      ></sn-tag-view-list>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="isAiCamera">
    <mat-header-cell *matHeaderCellDef>{{ 'common.ai' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container *ngIf="item.isAiEnabled; else notAiCamera">
        <sn-icon color="success">done</sn-icon>
      </ng-container>
      <ng-template #notAiCamera>
        <sn-icon color="danger">close</sn-icon>
      </ng-template>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="location">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.location' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">{{ item.location?.name }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="groups">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.groups' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span
        class="fs-text-truncate"
        [satPopoverAnchor]="p"
        (mouseenter)="popover('open', p, item)"
        (mouseleave)="popover('close', p, item)"
        >{{ item.groups?.length }}</span
      >
      <sat-popover #p horizontalAlign="after" verticalAlign="above" class="mat-elevation-z8">
        <div class="info-wrapper">
          <mat-list role="list">
            <mat-list-item *ngFor="let group of item.groups" role="listitem">{{
              group.name
            }}</mat-list-item>
          </mat-list>
        </div>
      </sat-popover>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="cameraView">
    <mat-cell
      *matCellDef="let element"
      [attr.colspan]="columns.length"
      [class.detailExpanded]="isExpanded(element.id) && !element.parentCamera"
    >
      <div
        *ngIf="!element.parentCamera"
        class="detail"
        [@snDetailExpand]="isExpanded(element.id) ? 'expanded' : 'collapsed'"
      >
        <sn-camera-table-details
          *ngIf="isExpanded(element.id)"
          [camera]="element"
          [canClip]="canClip"
          [canAdd]="canAdd"
          [canEdit]="canEdit"
          [canShare]="canShare"
          [canDelete]="canDelete"
          (changesInListOfTag)="getChangeFromListOfTag($event, element)"
          (edit)="edit.next($event)"
          (clip)="clip.next($event)"
          (clone)="clone.next($event)"
          (share)="share.next($event)"
          (shareInChat)="shareInChat.next($event)"
          (delete)="delete.next($event)"
          (add)="add.next($event)"
        ></sn-camera-table-details>
      </div>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="toggleExpanded(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
  <mat-row *matRowDef="let row; columns: ['cameraView']" class="detail-row"></mat-row>
</mat-table>
